<template>
  <modal
    :header-text="$t('modal.profileAddition')"
    :button-text="$t('global.add')"
    @action="addProfile()"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      <label :class="$style.label">{{ $t('modal.profileName') }}</label>
      <input
        v-model="profileName"
        type="text"
        :class="$style.input"
      >
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';
  import { addProdProfile, addWtProfile } from '@/api/methods/settings';

  export default {
    components: { Modal },
    props: ['type'],
    data: () => ({
      profileName: '',
    }),
    methods: {
      async addProfile() {
        let result = {};
        if (this.type === 'prod') result = await addProdProfile(this.profileName);
        if (this.type === 'wt') result = await addWtProfile(this.profileName);
        if (result === 'success') this.profileName = '';
        this.$emit('update');
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
    width: 60%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px;
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
  }
</style>
